module.exports = __webpack_public_path__ + "static/media/tutorial-04.aaf5975d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial-04.jpg
// module id = 325
// module chunks = 0